export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40860954dac6dabb50e9ef956923b531d7650b45c3&name=revalidateCommunity!'